<template>
  <section class="mapInfo-imperfect">
    <!--头部开始-->
    <header class="head">
      <i class="icon-notice"></i>
    </header>
    <!--头部结束-->

    <h3 class="apply-result">审核信息待完善</h3>

    <div class="content">
      <!--审核信息描述-->
      <p class="examine-desc">您的地图MOD：{{ mapName }} 需要完善一些信息，您的本次审核暂未通过，请继续完善。</p>

      <!--审核信息内容开始-->
      <p class="examine-content">
        拒绝原因：<br />
        {{ errorInfo || '没有填写' }}
      </p>
      <!--审核信息内容结束-->
    </div>

    <!--操作开始-->
    <div class="handle">
      <router-link class="item re-submit" :to="{ name: 'devMapinspect', params: {mapId: mapId, stage: stage} }">重新提交</router-link>
      <router-link class="item go-home" to="/home">返回开发者首页</router-link>
    </div>
    <!--操作结束-->
  </section>
</template>

<script type="text/ecmascript-6">
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'

  export default {
    // 地图审核信息不完善
    name: 'mapInfoImperfect',
    data () {
      return {
        // 地图 id
        mapId: this.$route.params.mapId,
        // 地图审核阶段
        stage: this.$route.params.stage,
        // 地图名称
        mapName: '',
        // 错误信息
        errorInfo: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 地图id
        formData.append('MapId', this.mapId)
        // 请求地图详细信息 api
        Axios.post(`${this.$api.root}/Developer/GetMapDevInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 获取地图名称
                this.mapName = res.DevInfo.MapName
                // 获取错误信息
                this.errorInfo = res.DevInfo.FailInfo
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Code)
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "mapInfoImperfect.styl";
</style>



// WEBPACK FOOTER //
// src/views/mapInfoImperfect/mapInfoImperfect.vue